<script lang="ts" setup>
import { computed, toRaw } from 'vue';
import IdeoFormCheckbox from './IdeoFormCheckbox.vue';

const model = defineModel<any[]>({
    required: false,
    default: (): any[] => ([])
});
const props = withDefaults(defineProps<{
    checked?: any[];
    valueField?: string;
    textField?: string;
    options?: Record<string, any>[];
    stacked?: boolean;
    columns?: number;
    disabled?: boolean;
    noPadding?: boolean;
    checkboxClass?: any;
    preventDisabled?: boolean;
}>(), {
    checked: undefined,
    valueField: 'value',
    textField: 'text',
    options: (): any => [],
    stacked: false,
    columns: 1,
    disabled: false,
    checkboxClass: '',
    preventDisabled: false
});
const emit = defineEmits<{
    (e: 'update:modelValue', value: any): void;
    (e: 'change', value: any, old: any): void;
}>();

const internal = computed(() => props.checked !== undefined ? props.checked : model.value);

const customClass = (): Record<string, boolean> =>
{
    return {
        'form-check-group': true,
        'd-flex flex-wrap flex-row': props.stacked === false,
        'd-flex flex-wrap flex-column': props.stacked !== false && props.columns == 1,
        [`row row-cols-${props.columns}`]: props.stacked !== false && props.columns > 1
    };
};

const isDisabled = (option: Record<string, any>): boolean =>
{
    if (props.preventDisabled)
        return false;

    if (props.disabled == true)
        return true;

    if ('disabled' in option)
        return option.disabled;

    if ('isActive' in option)
        return !option.isActive;

    return false;
};

const onChange = (value: any): void =>
{
    if (props.checked === undefined)
    {
        model.value = value;
    }

    emit('change', value, toRaw(internal.value));
};
</script>

<template>
    <fieldset :class="customClass()" :disabled="disabled">
        <slot name="default">
            <div v-for="(option, i) in options" :key="i" class="col">
                <IdeoFormCheckbox
                    :value="option[valueField]"
                    :disabled="isDisabled(option)"
                    :checked="internal"
                    :no-padding="noPadding"
                    :class="checkboxClass"
                    @change="onChange"
                >
                    <slot name="label" :option="option" :index="i">
                        {{ option[textField] }}
                    </slot>

                    <template #help>
                        <slot name="help" :option="option" :index="i" />
                    </template>
                </IdeoFormCheckbox>

                <div v-if="'options' in $slots" class="form-check-group-options">
                    <slot name="options" :option="option" :index="i" />
                </div>
            </div>
        </slot>
    </fieldset>
</template>

<style lang="scss">
.form-check-group {
    &-options {
        margin-left: 22px;
    }
}
</style>
